import { Component } from '@angular/core';

@Component({
  selector: 'uni-box-content-header-title',
  templateUrl: './uni-box-content-header-title.component.html',
  styleUrls: ['./uni-box-content-header-title.component.scss'],
})
export class UniBoxContentHeaderTitleComponent {
}
